/** Noi dung tieng Viet. Ten cac che do theo catalog `vi.json`. */
import type { LanguageContent } from '../registry.js';

export const VI: LanguageContent = {
  home: {
    intro: [
      'Retusch là trò chơi vẽ trực tuyến cho 2 đến 10 người, chơi ngay trong trình duyệt, không cần cài đặt và không cần tài khoản. Mỗi vòng bạn nhận một bức tranh đã bị xóa mất một vùng: hãy vẽ lại vùng đó sao cho nó biến mất trong tác phẩm. Rồi vai trò đảo ngược, và đến lượt bạn truy tìm bản sửa của những người khác.',
      'Gần như mọi trò chơi vẽ đều thưởng cho người được nhận ra sớm nhất. Retusch đòi hỏi điều ngược lại: thắng nghĩa là không bị nhìn thấy.',
    ],
    steps: [
      {
        title: 'Một bức tranh có lỗ',
        text: 'Bạn nhận một hình minh họa đã bị xóa mất một vùng.',
        painting: '1_airIsland',
        stage: 'masked',
      },
      {
        title: 'Bạn vẽ lại vùng đó',
        text: 'Bạn vẽ lại vùng đó sao cho nó hòa vào tác phẩm.',
        painting: '1_airIsland',
        stage: 'painted',
      },
      {
        title: 'Cuộc săn',
        text: 'Bức tranh trở lại cùng bản sửa của mọi người: hãy tìm ra chúng trước những người khác.',
        painting: '1_airIsland',
        stage: 'hunt',
      },
      {
        title: 'Lộ diện',
        text: 'Từng chỗ ẩn nấp hiện ra, và điểm số rơi xuống.',
        painting: '1_airIsland',
        stage: 'reveal',
      },
    ],
    modes: [
      {
        name: 'Săn chung',
        text: 'Mọi người cùng vẽ trên một bức tranh, mỗi người một vùng riêng. Rồi cuộc săn mở ra cho tất cả cùng lúc: một bản sửa chỉ được tìm thấy một lần, bởi người phát hiện ra nó đầu tiên. Đây là chế độ mặc định, chế độ lúc nào cũng có chuyện xảy ra.',
      },
      {
        name: 'Stream',
        text: 'Chủ phòng không vẽ: một mình đi tìm, trong khi tất cả những người khác ẩn mình trong bức tranh của họ. Được nghĩ ra cho phát trực tiếp, nơi cuộc săn chính là buổi diễn. Miễn phí mãi mãi.',
      },
      {
        name: 'Mỗi người một tranh',
        text: 'Mỗi người một tác phẩm. Bạn chỉ tìm bản sửa của một người, bằng một cú nhấp duy nhất. Luật đơn giản nhất của trò chơi, và cũng căng thẳng nhất.',
      },
      {
        name: 'Chỉ một người vẽ',
        text: 'Một vòng, một người vẽ, tất cả những người còn lại truy đuổi. Vai trò xoay vòng, và người vẽ nhìn chỗ ẩn nấp của mình đổ xuống hay trụ lại.',
      },
      {
        name: 'Battle royale',
        text: 'Vẫn cuộc săn ấy, nhưng bản sửa bị phát hiện đầu tiên sẽ loại tác giả của nó. Chơi đến người cuối cùng còn trụ lại, và không đếm một điểm nào.',
      },
      {
        name: 'Cuộc thi',
        text: 'Không ai đi tìm. Mọi người cùng vẽ lại một vùng trên cùng bức tranh, rồi mỗi người bình chọn bản sửa mình thích nhất. Mỗi phiếu nhận được đáng một điểm.',
      },
    ],
    faq: [
      {
        question: 'Cần bao nhiêu người chơi?',
        answer:
          'Từ 2 đến 10. Nếu bạn chơi một mình, một đối thủ tự động sẽ ngồi vào chỗ trống để ván đấu bắt đầu ngay. Từ bốn người trở lên, săn chung phát huy hết cái hay của nó.',
      },
      {
        question: 'Có miễn phí không?',
        answer:
          'Có. Ván nhanh, săn chung và chế độ stream đều miễn phí, không giới hạn thời gian và không giới hạn số ván. Các chế độ khác hiện cũng miễn phí.',
      },
      {
        question: 'Có cần tài khoản không?',
        answer:
          'Không. Bạn gõ một cái tên, nhấp chuột, rồi chơi. Tài khoản chỉ giữ lại tên và ảnh đại diện từ ván này sang ván khác: nó vẫn là tùy chọn.',
      },
      {
        question: 'Chơi trên điện thoại được không?',
        answer:
          'Được, giao diện thích ứng với cảm ứng: thanh công cụ thu gọn, kính lúp dưới ngón tay, chạm hai lần để phóng to. Dù vậy, vẽ bằng chuột và trên màn hình lớn vẫn chính xác hơn.',
      },
      {
        question: 'Mời bạn bè bằng cách nào?',
        answer:
          'Bạn tạo một phòng, sao chép liên kết mời rồi dán vào đâu tùy thích. Bạn bè của bạn đến thẳng bàn chơi, không tài khoản và không cài đặt.',
      },
      {
        question: '“Bản sửa” là gì?',
        answer:
          'Là thứ bạn vẽ vào vùng đã bị xóa. Nếu thành công, nó bị nhầm là một mảnh của bức tranh gốc và không ai tìm ra. Nếu hỏng, nó đập ngay vào mắt.',
      },
    ],
    headings: {
      intro: 'Trò chơi vẽ mà bạn phải biến mất',
      steps: 'Chơi thế nào',
      modes: 'Sáu chế độ chơi',
      faq: 'Câu hỏi thường gặp',
      more: 'Tìm hiểu thêm',
    },
    links: {
      rules: 'Đọc luật đầy đủ và cách tính điểm',
      modes: 'So sánh chi tiết các chế độ',
    },
  },

  howToPlay: {
    title: 'Cách chơi Retusch',
    summary:
      'Luật đầy đủ của Retusch: diễn biến một vòng, cách tính điểm cho cả hai phía, các công cụ vẽ và mẹo để ẩn mình cũng như để đi tìm.',
    sections: [
      {
        heading: 'Ý tưởng trong ba câu',
        blocks: [
          'Bạn nhận một bức tranh đã bị xóa mất một vùng, và bạn vẽ lại vùng đó sao cho không ai để ý.',
          'Rồi mọi người ngắm các bức tranh đã sửa và đi tìm những vùng được vẽ lại.',
          'Bạn ghi điểm khi tìm ra nhanh, và cũng ghi điểm suốt thời gian chỗ ẩn nấp của bạn còn trụ được.',
        ],
      },
      {
        heading: 'Diễn biến một vòng',
        blocks: [
          'Một ván nối tiếp những vòng giống nhau, mặc định là năm vòng. Mỗi vòng đi qua ba thời điểm.',
          {
            list: [
              'Vẽ. Bạn nhận bức tranh và vùng của mình, và mặc định có 2 phút để vẽ lại. Nút Xong nghĩa là nộp bài: ngay khi mọi người đã nộp, vòng đấu đi tiếp mà không chờ đồng hồ.',
              'Cuộc săn. Bức tranh xuất hiện lại cùng các bản sửa, và bạn mặc định có 30 giây để phát hiện ra chúng. Một cú nhấp vào vùng được vẽ lại sẽ hé lộ nó cho cả bàn.',
              'Lộ diện. Mọi chỗ ẩn nấp đều được đóng khung và gọi tên, kể cả những chỗ không ai nhìn thấy. Một thanh trượt cho phép so bức tranh đã sửa với tác phẩm gốc.',
            ],
          },
        ],
      },
      {
        heading: 'Cách tính điểm',
        blocks: [
          'Hai bộ đếm chạy song song và đối nghịch nhau: người đi tìm muốn thật nhanh, người đã vẽ muốn vùng của mình trụ được lâu.',
          {
            list: [
              'Cho người đi tìm: 1000 điểm nếu bạn tìm ra trong 3 giây đầu, rồi giảm đều xuống 100 điểm ở cuối giai đoạn. Nhấp hụt hoặc không tìm ra gì đều không được gì.',
              'Cho người vẽ: chỉ 100 điểm nếu vùng của bạn đổ ngay lập tức, rồi tăng đều lên 800 điểm nếu nó trụ được đến cùng. Một bản sửa không ai tìm ra được điểm tối đa, 800 điểm.',
            ],
          },
          'Người vẽ chỉ được trả công một lần, lúc lộ diện, và theo người tìm nhanh nhất. Vậy nên hai người hay tám người cùng tìm bạn đều như nhau: chỉ người tìm ra bạn đầu tiên mới tính.',
          'Cách tính điểm không đổi dù bạn đặt giai đoạn dài bao nhiêu. Kéo dài cuộc săn không dịch chuyển hai đầu mút, chỉ thay đổi độ dốc giữa chúng.',
          'Mỗi vòng chỉ được sai một lần. Cú nhấp đầu tiên không chạm vào bản sửa nào sẽ khép lại cuộc săn của bạn: không có luật này thì người ta cứ rà bừa khắp ảnh cho tới khi trúng. Hai thao tác không mất gì: nhấp vào vùng của chính mình, và nhấp vào một bản sửa đã bị tìm ra.',
        ],
      },
      {
        heading: 'Các công cụ vẽ',
        blocks: [
          {
            list: [
              'Cọ (B): ba cỡ nhanh, cùng một thanh trượt cho cỡ chính xác. Phím tắt 1, 2 và 3 chọn ba cỡ đó.',
              'Xô sơn (P): tô đầy một mảng phẳng trong một lần và không bao giờ tràn ra khỏi vùng của bạn.',
              'Ống hút màu (I): lấy màu ở bất kỳ đâu trên bức tranh. Giữ phím Alt sẽ chuyển sang nó trong một cú nhấp rồi trả lại công cụ trước đó.',
              'Bàn tay (H): di chuyển khung nhìn. Ở ngoài vùng của bạn, cọ và xô sơn cũng làm y như vậy, nên gần như bạn chẳng bao giờ phải đổi công cụ.',
              'Hoàn tác (Ctrl+Z hoặc Cmd+Z): lùi lại từng nét một, tối đa ba mươi lần. Không có làm lại.',
              'Màu nền ở cuối bảng màu: đó là màu khởi đầu của vùng bạn. Vẽ bằng nó chính là xóa, chỉ khác ở chỗ đây vẫn là một nét như mọi nét khác, có thể hoàn tác và có thể phủ lên. Vì vậy trò chơi không có cục tẩy.',
            ],
          },
        ],
      },
      {
        heading: 'Năm mẹo để ẩn mình',
        blocks: [
          {
            list: [
              'Hãy lấy màu bằng ống hút màu, đừng đoán. Ống hút màu cho đúng màu của xung quanh: một mảng chỉ lệch chút thôi cũng lộ từ xa, còn mảng đúng màu thì thành vô hình.',
              'Kéo dài những gì cắt ngang vùng của bạn. Một bức tường, một đường chân trời, một cành cây đi vào từ bên này phải đi ra ở bên kia đúng chỗ của nó. Một đường đứt quãng là dấu vết đầu tiên mà người chơi lâu năm tìm kiếm.',
              'Hãy vẽ các góc trước. Đây là lỗi hay gặp nhất: phần giữa được chăm chút, bốn góc vẫn nguyên màu nền khởi đầu, và hình vuông hiện ra bằng mắt thường mà chẳng cần nhìn tới nét vẽ.',
              'Đi từ tổng thể đến chi tiết. Trước tiên đặt các mảng màu lớn bằng cọ to, rồi mới tinh chỉnh. Làm ngược lại thì cả thời gian dồn vào một góc trong khi phần còn lại vẫn trống.',
              'Hãy nhại lại mức độ chi tiết của xung quanh. Một vùng quá sạch giữa một chỗ rậm rạp cũng lộ như một vùng làm ẩu giữa một mảng màu phẳng.',
            ],
          },
        ],
      },
      {
        heading: 'Bốn mẹo để đi tìm',
        blocks: [
          {
            list: [
              'Hãy tìm những đường bị đứt quãng. Một mép, một sợi dây, góc bàn xê dịch một sợi tóc: gần như lúc nào cũng nằm ở đó.',
              'Quét trước, phóng to sau. Ở khung nhìn toàn cảnh, một vùng hòa kém trông như một vệt loang. Phóng to là để xác nhận, không phải để tìm.',
              'Hãy nghi ngờ những chỗ quá mượt. Một mặt phẳng hoàn toàn đồng đều giữa một vùng có vân cũng đáng ngờ như một vệt làm ẩu.',
              'Đừng nhấp bừa. Bạn chỉ có quyền sai một lần: mất ba giây để kiểm tra vẫn hơn mất cả vòng.',
            ],
          },
        ],
      },
      {
        heading: 'Còn tùy theo chế độ thì sao?',
        blocks: [
          'Tất cả những điều trên mô tả săn chung, chế độ mặc định. Các chế độ khác thay đổi ai vẽ, ai tìm và thắng bằng cách nào: chi tiết từng chế độ nằm ở trang các chế độ chơi.',
        ],
      },
    ],
  },

  modes: {
    title: 'Các chế độ chơi của Retusch',
    summary:
      'Sáu cách chơi Retusch: săn chung, stream, mỗi người một tranh, chỉ một người vẽ, battle royale và cuộc thi. Diễn biến, số người chơi nên có và thời lượng.',
    sections: [
      {
        heading: 'Săn chung',
        blocks: [
          'Chế độ mặc định, và cũng là chế độ nên bắt đầu.',
          'Mọi người cùng vẽ trên một bức tranh, mỗi người một vùng riêng. Khi các bản sửa đã nộp xong, tác phẩm trở lại nguyên vẹn và cuộc săn mở ra cho tất cả cùng lúc. Một bản sửa chỉ được tìm thấy một lần, bởi người phát hiện ra nó đầu tiên: nó hiện ra cho cả bàn rồi rời khỏi cuộc chơi. Bạn không bao giờ tìm thấy bản của chính mình, và một chỗ ẩn nấp không ai nhìn ra sẽ cho tác giả điểm tối đa.',
          'Lý tưởng cho nhóm đông: không có khoảng chết, mọi người cùng tìm một lúc và mỗi lần phát hiện đều hiện lên màn hình của tất cả.',
          'Nên chơi: 3 đến 10 người.',
        ],
      },
      {
        heading: 'Stream',
        blocks: [
          'Hình ảnh soi gương của chế độ “chỉ một người vẽ”, nghĩ ra cho phát trực tiếp.',
          'Tất cả người chơi cùng vẽ trên một bức tranh, trừ chủ phòng. Rồi chỉ mình chủ phòng đi tìm, trong khi khán giả xem họ vật lộn. Họ không ghi điểm và không có mặt trong bảng xếp hạng: ván đấu diễn ra giữa những người ẩn mình, còn họ dẫn dắt cuộc săn. Họ được sai bao nhiêu lần tùy thích, luật chỉ sai một lần không áp dụng cho họ.',
          'Lý tưởng cho một buổi phát trực tiếp, và vì một lý do rất cụ thể: vì chủ phòng không vẽ nên khán giả không bao giờ thấy chỗ ẩn nấp của họ hình thành. Ở các chế độ khác, khán giả nhìn họ tô vùng của mình, và cuộc săn chẳng còn bí mật gì nữa.',
          'Nên chơi: 4 đến 10 người. Miễn phí, và sẽ vẫn như vậy.',
        ],
      },
      {
        heading: 'Mỗi người một tranh',
        blocks: [
          'Mỗi người chơi nhận tác phẩm của riêng mình và giấu bản sửa vào đó. Đến lúc săn, bạn được giao bức tranh của đúng một người khác, và bạn có một cú nhấp duy nhất để chỉ ra vùng được vẽ lại. Không đua tranh, không chen lấn: chỉ có bạn, một bức tranh và một quyết định.',
          'Lý tưởng khi chơi đôi, hoặc khi muốn một ván thong thả mà ai cũng có thời gian của mình.',
          'Nên chơi: 2 đến 10 người.',
        ],
      },
      {
        heading: 'Chỉ một người vẽ',
        blocks: [
          'Một vòng, một người vẽ, tất cả những người còn lại truy đuổi.',
          'Mỗi vòng chỉ một người nhận tranh. Những người khác chờ, rồi đi tìm bản sửa của người đó, ai cũng được chấm theo thời gian của riêng mình. Người vẽ được chấm theo người tìm nhanh nhất, và nhìn lại chỗ ẩn nấp của mình, đứng yên, trong lúc nó bị lùng sục. Vai trò xoay vòng: ở đây thiết lập số vòng đếm theo lượt trọn vẹn, vì một ván chỉ công bằng khi ai cũng vẽ đúng bằng nhau.',
          'Lý tưởng cho nhóm nhỏ muốn so tài trong điều kiện như nhau, từng bức một.',
          'Nên chơi: 3 đến 6 người, đông hơn thì phải chờ lâu.',
        ],
      },
      {
        heading: 'Battle royale',
        blocks: [
          'Vẫn săn chung, thêm một người bị loại mỗi vòng.',
          'Cùng bức tranh chung ấy, cùng cuộc săn đồng thời ấy. Nhưng ở đây không đếm một điểm nào: câu hỏi duy nhất là ai còn lại. Người chơi bị phát hiện bản sửa đầu tiên sẽ rời cuộc chơi. Những người khác vẫn tìm tiếp đến hết vòng, việc này không loại thêm ai nhưng cho mỗi người một thứ hạng của vòng, hiện ngay trên vùng của họ. Nếu không ai bị tìm ra thì không ai bị loại.',
          'Lý tưởng để khép lại một buổi tối: căng thẳng dâng lên khi bàn chơi vơi dần, và vòng cuối chỉ còn hai người.',
          'Nên chơi: 4 đến 10 người.',
        ],
      },
      {
        heading: 'Cuộc thi',
        blocks: [
          'Chế độ duy nhất mà không ai đi tìm.',
          'Mọi người cùng vẽ lại một vùng trên cùng bức tranh. Rồi mỗi người xem qua bản sửa của những người khác, theo nhịp của mình, và bình chọn bản mà mình thấy đạt nhất. Mỗi phiếu nhận được đáng một điểm cho tác giả. Trong lúc bình chọn, các tác giả đều ẩn danh, và không ai được bầu cho chính mình: tên tuổi và số phiếu chỉ lộ ra lúc lộ diện.',
          'Lý tưởng khi nhóm có nhiều kiểu người, hoặc khi ai đó thích vẽ mà không bị đồng hồ săn thúc ép.',
          'Nên chơi: 3 đến 10 người.',
        ],
      },
    ],
  },
  modeTable: [
    { name: 'Săn chung', players: '3 đến 10', duration: '15-20 phút' },
    { name: 'Stream', players: '4 đến 10', duration: '15-20 phút' },
    { name: 'Mỗi người một tranh', players: '2 đến 10', duration: '15-20 phút' },
    { name: 'Chỉ một người vẽ', players: '3 đến 6', duration: '20-35 phút' },
    { name: 'Battle royale', players: '4 đến 10', duration: '20-30 phút' },
    { name: 'Cuộc thi', players: '3 đến 10', duration: '10-15 phút' },
  ],
  modeTableHeadings: ['Chế độ', 'Người chơi', 'Thời lượng'],
  premium: {
    heading: 'Chế độ miễn phí và chế độ trả phí',
    blocks: [
      'Săn chung và chế độ stream miễn phí, vĩnh viễn.',
      'Bốn chế độ còn lại sẽ tính phí khi TẠO một ván đấu, và chỉ ở đó. Tham gia thì luôn miễn phí: chỉ cần một người ở bàn đã mở khóa trò chơi là tất cả đều chơi được mọi chế độ, không tài khoản và không trả tiền.',
      'Mở khóa sẽ là một lần mua duy nhất, không thuê bao, và cũng gỡ quảng cáo cho tài khoản đã mua. Trong lúc chờ, mọi chế độ đều mở cho tất cả mọi người.',
    ],
  },

  blog: [
    {
      slug: 'quest-ce-que-retusch',
      title: 'Retusch là gì?',
      date: '2026-08-21',
      summary:
        'Một trò chơi vẽ trực tuyến cho nhiều người, gần với Gartic Phone về hình thức, nhưng cơ chế lại gợi nhớ Meccha Chameleon: thay vì được nhận ra, bạn tìm cách biến mất.',
      sections: [
        {
          heading: 'Trò chơi vẽ mà bị nhận ra là thua',
          blocks: [
            'Retusch là trò chơi vẽ trực tuyến cho 2 đến 10 người. Mỗi vòng bạn nhận một hình minh họa đã bị xóa mất một vùng, và phải vẽ lại vùng đó sao cho nó hòa vào tác phẩm. Rồi mọi người ngắm các bức tranh đã sửa và đi tìm những vùng được vẽ lại.',
            'Điều làm nên khác biệt gói gọn trong một câu: thắng nghĩa là không bị nhìn thấy.',
          ],
        },
        {
          heading: 'Điểm chung với Gartic Phone',
          blocks: [
            'Hình thức thì y hệt: bạn mở một liên kết, gõ một cái tên, rồi chơi. Không tài khoản, không cài đặt, không phần mềm phải tải. Trò chơi chạy trong trình duyệt và một ván khởi động trong vài giây. Bạn mời bạn bè bằng cách dán liên kết vào một cuộc trò chuyện, và bàn chơi đầy dần.',
            'Nhịp chơi cũng quen thuộc: những vòng ngắn, một đồng hồ, một giai đoạn vẽ rồi một giai đoạn để lộ ra người khác đã làm gì. Và nhất là màn lộ diện tập thể cuối vòng, khi ai cũng bình phẩm thứ mình đang thấy. Vẫn là niềm vui chung ấy.',
            'Cũng như ở Gartic Phone, không cần biết vẽ. Một mảng trời đặt đúng chỗ thắng một kiệt tác lem ra ngoài.',
          ],
        },
        {
          heading: 'Điều lấy từ Meccha Chameleon',
          blocks: [
            'Nhưng ở tầng sâu, cơ chế lại nằm chỗ khác. Trong Meccha Chameleon, trò chơi ba chiều trên Steam, bạn tô màu cho nhân vật của chính mình rồi đặt nó vào một khung cảnh, hy vọng không ai phân biệt được nó với xung quanh. Chiến thắng đến từ sự giống nhau và chỗ đặt khéo, không phải từ hành động.',
            'Retusch lấy ý đó và đưa nó trở về với hình ảnh. Bạn không chọn chỗ để nấp, vùng là do trò chơi giao; bù lại, bạn tự tay làm ra toàn bộ thứ sẽ nằm trong đó. Chỗ ẩn nấp thành công khi ánh mắt lướt qua nó mà không dừng lại.',
            'Và như trong mọi trò chơi ngụy trang, căng thẳng đến từ vai trò kép. Bạn vừa là kẻ ẩn mình vừa là thợ săn: trong lúc bạn soi bức tranh tìm một mảng khả nghi, có người đang soi bức của bạn.',
          ],
        },
        {
          heading: 'Điều không nơi nào khác có',
          blocks: [
            'Cách tính điểm thưởng cho hai phía theo hai chiều ngược nhau. Người đi tìm càng tìm sớm càng được nhiều; người đã vẽ càng giữ được vùng lâu càng được nhiều. Một bản sửa không ai nhìn ra sẽ cho tác giả điểm tối đa.',
            'Từ đó sinh ra một lối chơi rất riêng: bạn không cố làm cho đẹp, bạn cố làm cho đúng. Lấy đúng màu, kéo dài một đường đúng chỗ nó phải tới, không chừa một góc trống nào. Đó là những động tác quan sát trước khi là động tác vẽ.',
            'Muốn hiểu trong thực tế, đơn giản nhất là đọc luật đầy đủ, hoặc mở một ván nhanh: nó khởi động không thiết lập và không chờ đợi.',
          ],
        },
      ],
    },
    {
      slug: 'comment-etre-imbattable',
      title: 'Làm sao để bất bại trong Retusch',
      date: '2026-08-21',
      summary:
        'Phím tắt, phương pháp đi từ tổng thể đến chi tiết và lỗi để trống các góc: ba điều tách một người mới khỏi một người chơi mà không ai tìm ra nổi.',
      sections: [
        {
          heading: 'Học phím tắt là nhân đôi thời gian có ích',
          blocks: [
            'Hai phút vẽ trôi rất nhanh khi cứ phải đưa chuột đi lấy từng công cụ. Phím tắt dễ dàng lấy lại hai ba chục giây mỗi vòng, và đó đúng là số giây bạn sẽ dành cho chi tiết.',
            {
              list: [
                'B cho cọ, P cho xô sơn, I cho ống hút màu, H cho bàn tay.',
                '1, 2 và 3 cho ba cỡ cọ, khỏi phải ghé qua thanh công cụ.',
                'Ctrl+Z, hay Cmd+Z trên Mac, để hoàn tác từng nét một.',
                'Giữ phím Alt sẽ chuyển sang ống hút màu và trả lại công cụ trước đó ngay khi bạn thả ra. Đây là phím hữu ích nhất: bạn lấy màu giữa lúc đang vẽ mà không hề đổi công cụ.',
              ],
            },
            'Một lưu ý cho bàn phím AZERTY: các phím 1, 2 và 3 vẫn chạy mà không cần Shift, dù trên bàn phím của bạn chúng ghi &, é và ". Trò chơi đọc vị trí của phím, chứ không đọc ký tự mà phím tạo ra.',
          ],
        },
        {
          heading: 'Hãy vẽ từ tổng thể đến chi tiết',
          blocks: [
            'Lỗi kinh điển của người mới là bắt đầu từ một góc rồi chăm chút cho nó. Đồng hồ hết giờ, ba phần tư vùng vẫn còn là nền, và bản sửa lộ từ mười mét.',
            'Cách làm đúng thì ngược lại. Hãy bắt đầu bằng cọ to, hoặc bằng xô sơn, và đặt các mảng màu lớn: bầu trời, bức tường, cái bóng dưới đất. Trong hai mươi giây, vùng của bạn đã có đúng dáng vẻ tổng thể và không còn đọc ra như một khối lạc lõng.',
            'Chỉ đến lúc đó mới giảm cỡ cọ và xử lý các chỗ chuyển tiếp: đường chân trời cắt ngang, mép một vật thể, sắc độ đổi ở lưng chừng. Nếu thiếu giờ, bạn mất chi tiết chứ không mất cả vòng.',
            'Hãy luôn lấy màu bằng ống hút màu thay vì chọn trên bảng màu. Một sắc gần đúng đủ để tố cáo cả một vùng, còn sắc đúng thì khiến nó vô hình.',
          ],
        },
        {
          heading: 'Đừng bao giờ để trống các góc',
          blocks: [
            'Đây là dấu vết số một, và là thứ đầu tiên người chơi lâu năm tìm. Một vùng có phần giữa được xử lý kỹ nhưng bốn góc vẫn nguyên màu nền sẽ vẽ ra một hình chữ nhật hoàn hảo trên màn hình. Thậm chí chẳng cần nhìn tới nét vẽ: hình khối ấy đập ngay vào mắt.',
            'Hãy tập thói quen xử lý viền trước rồi mới tới giữa. Một cái khung hòa khéo sẽ tha thứ cho phần ruột làm qua loa; ngược lại thì không bao giờ đúng.',
            'Cứ cố ý lem ra ngoài mép. Trò chơi cắt nét của bạn ngay ở ranh giới vùng, nên đi xa hơn hẳn cũng chẳng mất gì, và đó là cách duy nhất để chắc chắn không một điểm ảnh nền nào sót lại trong góc.',
          ],
        },
        {
          heading: 'Và khi đến lượt bạn đi tìm',
          blocks: [
            'Trước hết hãy quét cả bức tranh mà không phóng to: một vùng hòa kém trông như một vệt loang, còn phóng to chỉ để xác nhận. Rồi hãy lần theo những đường dài, những đường cắt ngang bức ảnh: một cái mép xê dịch một sợi tóc gần như luôn là một bản sửa.',
            'Và nhớ rằng mỗi vòng bạn chỉ có quyền sai một lần. Ba giây kiểm tra rẻ hơn cả một vòng.',
          ],
        },
      ],
    },
    {
      slug: 'jeu-de-dessin-entre-amis',
      title: 'Trò chơi vẽ cho một tối với bạn bè',
      date: '2026-08-21',
      summary:
        'Vì sao Retusch hợp với nhóm nhỏ, cách mời bằng một liên kết dán vào, và vì sao chỉ cần một người là mở khóa được các chế độ trả phí cho cả bàn.',
      sections: [
        {
          heading: 'Một trò chơi không đòi hỏi gì ở ai',
          blocks: [
            'Trở ngại lớn nhất của một tối chơi game từ xa là khâu cài đặt. Một tài khoản phải lập, một phần mềm phải tải, một phiên bản không khớp: nửa nhóm bỏ cuộc trước cả khi chơi.',
            'Retusch chạy trong trình duyệt. Bạn bè của bạn nhấp vào một liên kết, gõ một cái tên, và thấy mình đã ngồi vào bàn. Không có gì phải cài, không có gì phải lập, và nó chạy tốt cả trên máy tính lẫn trên điện thoại.',
            'Một điều nữa quan trọng khi chơi nhóm: không ai bị bỏ lại vì không biết vẽ. Trò chơi không đòi bạn tả lại điều gì, chỉ đòi bạn khớp một vùng với thứ bao quanh nó. Người vẽ dở nhưng quan sát tốt thường thắng.',
          ],
        },
        {
          heading: 'Mời trên thực tế',
          blocks: [
            'Hãy tạo một phòng từ màn hình khởi đầu. Bỏ dấu “phòng công khai” nếu các bạn muốn chơi riêng với nhau: lời mời bằng liên kết khi đó là lối vào duy nhất.',
            'Sao chép liên kết bằng nút dành riêng cho việc đó, rồi dán vào nhóm chat, kênh thoại hay ứng dụng nhắn tin của các bạn. Nó chứa mã phòng: bạn bè của bạn đáp thẳng xuống bàn của bạn.',
            'Bạn có thể chỉnh ván đấu trong lúc mọi người kéo đến: chế độ, số vòng, thời gian vẽ, kích thước vùng và cả các nhóm hình ảnh. Chưa có gì cố định cho tới khi bạn bấm bắt đầu.',
          ],
        },
        {
          heading: 'Một người trả, cả nhóm chơi',
          blocks: [
            'Hai chế độ miễn phí mãi mãi: săn chung, tức chế độ mặc định, và chế độ stream.',
            'Các chế độ khác sẽ tính phí, nhưng chỉ khi TẠO một ván đấu. Tham gia thì vẫn miễn phí, không kèm điều kiện. Trên thực tế, chỉ cần một người trong nhóm đã mở khóa trò chơi là cả bàn được hưởng mọi chế độ, không tài khoản và không trả một đồng nào.',
            'Mở khóa là một lần mua duy nhất, không thuê bao.',
          ],
        },
        {
          heading: 'Chế độ nào cho nhóm nào',
          blocks: [
            'Ba hay bốn người thì săn chung là đủ, và chỉ một vòng là hiểu. Từ sáu người trở lên nó mới thật sự hay: các phát hiện nối nhau và màn hình không ngừng động đậy.',
            'Để khép lại một buổi tối, hãy thử battle royale: bàn chơi vơi dần từng vòng và vòng cuối chỉ còn hai người. Với một nhóm nhiều kiểu người, trong đó có ai đó thích vẽ thong thả, cuộc thi gỡ bỏ toàn bộ sức ép của đồng hồ săn.',
          ],
        },
      ],
    },
    {
      slug: 'jeu-de-dessin-en-stream',
      title: 'Trò chơi vẽ để phát trực tiếp',
      date: '2026-08-21',
      summary:
        'Retusch có một chế độ nghĩ ra cho phát trực tiếp, trong đó streamer đi tìm một mình còn khán giả thì ẩn mình. Cách dùng nó, và những chế độ nào khác hợp với việc có khán giả.',
      sections: [
        {
          heading: 'Một chế độ làm riêng cho việc này',
          blocks: [
            'Chế độ stream đảo ngược vai trò. Tất cả người chơi cùng vẽ trên một bức tranh, trừ chủ phòng, người hoàn toàn không vẽ. Rồi chỉ mình chủ phòng đi tìm, trong khi khán giả ngồi xem.',
            'Đó đúng là tình huống mà một buổi phát trực tiếp cần, và vì một lý do rất cụ thể: vì chủ phòng không vẽ nên chỗ ẩn nấp của họ không tồn tại, và khung chat chẳng thấy điều gì lẽ ra không được thấy. Ngược lại, khán giả biết chỗ ẩn nấp của những người chơi khác, và có thể xem chủ phòng đi lướt qua chúng ba lần liên tiếp.',
            'Hai điều luật đã được viết cho trường hợp này. Streamer không ghi điểm và không có mặt trong bảng xếp hạng: ván đấu diễn ra giữa những người ẩn mình, còn họ dẫn dắt buổi diễn. Và họ được sai bao nhiêu lần tùy thích, trong khi mọi chế độ khác dừng lại ở lần sai đầu tiên. Một buổi phát trực tiếp không thể kết thúc vì một cú nhấp xui xẻo.',
            'Chế độ stream miễn phí, và sẽ vẫn như vậy.',
          ],
        },
        {
          heading: 'Cuộc thi, ý hay thứ hai',
          blocks: [
            'Ở chế độ cuộc thi, mọi người cùng vẽ lại một vùng trên cùng bức tranh, rồi mỗi người bình chọn bản sửa mình thích nhất. Không còn gì để tìm nữa, chỉ còn để đánh giá.',
            'Trước khán giả thì nó chạy rất tốt, và vì cùng lý do với chế độ stream: không có gì để tìm, nên cũng chẳng có gì để khung chat làm hỏng. Các bài dự thi được đặt cạnh nhau mà so, việc bình chọn tạo một khoảnh khắc hồi hộp, và màn công bố tên cho một cái kết dứt khoát. Đây cũng là chế độ ngắn nhất.',
          ],
        },
        {
          heading: 'Còn các chế độ khác',
          blocks: [
            'Không gì bắt buộc phải dùng chế độ dành riêng, nhưng khi đó nên chơi với bạn bè thay vì với khung chat. Ở mọi chế độ khác, streamer tô vùng của mình ngay trên màn hình: khán giả thấy nó hình thành và biết đáp án trước cả khi cuộc săn bắt đầu.',
            'Ngược lại, một ván chơi giữa bạn bè lại rất dễ theo dõi từ bên ngoài: giai đoạn vẽ cho thấy từng người dựng chỗ ẩn nấp của mình, còn màn lộ diện mở toang mọi vùng cùng lúc, kèm tên tác giả.',
          ],
        },
        {
          heading: 'Kéo khung chat vào ván đấu',
          blocks: [
            'Liên kết mời là thứ duy nhất phải chia sẻ. Dán nó vào khung chat và những người đến trước sẽ lấp đầy bàn: không tài khoản phải lập, không phải tải gì, không phải xếp hàng.',
            'Giới hạn số người chỉnh trong phòng, từ 2 đến 10. Với lượng khán giả đông, hãy mở nhiều ván ngắn thay vì một ván dài: một vòng kéo dài chưa tới ba phút.',
          ],
        },
      ],
    },
    {
      slug: 'nouveautes',
      title: 'Có gì mới trong Retusch',
      date: '2026-08-21',
      summary:
        'Những thay đổi trong lối chơi của Retusch, từ mới nhất đến cũ nhất: chế độ mới, luật mới, cải tiến ở phần vẽ và phần săn.',
      sections: [
        {
          heading: 'Tháng 8 năm 2026',
          blocks: [
            {
              list: [
                'Vùng phải vẽ lại không còn khởi đầu bằng một ô vuông trắng, mà bằng màu chiếm nhiều nhất của thứ nó che đi. Không còn mất nửa thời gian để tô lại một cái nền vốn không hề tồn tại trong bức tranh.',
                'Xô sơn không còn để lại viền sáng dọc theo các nét: từ nay nó luồn xuống dưới mép đã được làm mềm của chúng.',
                'Battle royale không còn đếm điểm. Người bị phát hiện đầu tiên rời cuộc chơi, và mỗi người nhận một thứ hạng của vòng, hiện trên vùng của mình, từ đỏ tới xanh lá.',
                'Chế độ stream cho streamer thử bao nhiêu lần tùy thích: lần sai đầu tiên không còn khép lại vòng đấu.',
                'Ở chế độ khán giả, giờ đã có thể di chuyển và phóng to bức tranh mà bạn đang xem người khác dựng lên.',
                'Biểu tượng cảm xúc bay lên từ tên người gửi trong danh sách người chơi, thay vì dâng lên từ cạnh dưới màn hình.',
                'Ở ngoài vùng phải vẽ lại, cọ và xô sơn di chuyển khung nhìn: muốn dời chỗ thì không còn phải lấy công cụ bàn tay nữa.',
                'Tên trò chơi ở góc trên bên trái trong lúc chơi sẽ đưa về trang khởi đầu sau khi xác nhận.',
                'Tiếng Nhật và tiếng Hàn được thêm vào mười lăm ngôn ngữ vốn có.',
              ],
            },
          ],
        },
        {
          heading: 'Tháng 7 năm 2026',
          blocks: [
            {
              list: [
                'Chế độ cuộc thi mới: mọi người cùng vẽ lại một vùng, rồi mỗi người bình chọn bản sửa mình thích nhất.',
                'Chế độ stream mới, nghĩ ra cho phát trực tiếp: chủ phòng đi tìm một mình trong khi khán giả ẩn mình.',
                'Các nhóm hình ảnh thay cho các mức độ khó. Bạn đánh dấu thứ mình muốn thấy, và mỗi nhóm cho xem một bức tranh làm mẫu.',
                'Hai vòng liên tiếp không còn rơi vào cùng một bức tranh, và các nhóm đã đánh dấu luân phiên nhau từ vòng này sang vòng khác.',
                'Thư viện cuối ván cho phép xem lại một bản sửa từng nét một và xuất nó ra thành ảnh hoặc GIF động.',
              ],
            },
          ],
        },
      ],
    },
  ],

  ui: {
    atAGlance: 'Tóm tắt',
    allArticles: 'Tất cả bài viết',
    theRules: 'Luật chơi',
    theModes: 'Các chế độ chơi',
  },
};
